import axios from "config/axios";

const ENDPOINT = "/weekly-chek-comment";

export const weeklyCheck = (date: string, tenantId: number) =>
  axios.post(`${ENDPOINT}/get-by-date`, {
    param: { date },
    tenantId,
  });
